import React, { useState } from 'react'
import Tools from '../../../../../Misc/Tools';
import CoreGeneralButton from '../../core-general-button';

const CoreDebugSideMenu = (props: CoreDebugSideMenuConfig) => {
	return (
		<div style={{
			width: '350px',
			height: '180px',
			backgroundColor: 'rgba(0,0,0,0.5)'
		}}>
			<div style={{
				width: '100%',
				height: '50px',
			}}>
				<p className='' style={{ color: 'white', textAlign: 'center' }}>Properties</p>
			</div>
			<div style={{
				width: '100%',
				height: '50px',
			}}>
				{props.hideDropdown ? (null) : <select style={{ width: '100%', height: '100%' }} onChange={(evt) => {
					props.onIndexChanged(evt.target.selectedIndex);
				}} defaultValue={props.defaultVal}>
					{props.allValues.map((item: CoreDebugButtonType<any>, index: number) => {
						return (
							<option value={item.key}>{item.key}</option>
						)
					})}
				</select>}
			</div>
			<br />
			<div style={{
				width: '100%',
				height: '50px',
			}}>
				<CoreGeneralButton width='100%'
					height='100%'
					onClick={() => {
						navigator.clipboard.writeText(props.codeSnippet).then(() => {
							Tools.showToastNotification('Code snipped copied to clipboard');
						  }, (err) => {
							Tools.showToastNotification('Could not copy text: ' + err);
						  });
					}}
					onRenderContent={() => {
						return (
							<p className='center-element' style={{ textAlign: 'center' }}>Copy Snippet To Clipboard</p>
						)
					}}
					isSelected={false}
					isDisabled={false}
					ariaLabel={''}></CoreGeneralButton>
			</div>
		</div>
	);
}

export interface CoreDebugSideMenuConfig {
	defaultVal?: string;
	hideDropdown?: boolean;
	allValues?: CoreDebugButtonType<any>[];
	codeSnippet?: string;
	onIndexChanged?: (indx: number) => void;
}
export default CoreDebugSideMenu;

export class CoreDebugButtonType<TType> {
	key: TType;
	value: string;
}
